.zhibi-react-page {
  background: #f4f6f8;
  color: #15202b;
  min-height: calc(100vh - 64px);
}

.zhibi-hero-card,
.zhibi-section-card {
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
  margin-bottom: 16px;
}

.zhibi-hero-card .ant-typography,
.zhibi-section-card .ant-typography {
  margin-bottom: 0;
}

.zhibi-page-nav {
  margin-bottom: 14px;
}

.zhibi-page-nav .ant-breadcrumb {
  color: #64748b;
  font-size: 13px;
}

.zhibi-page-nav .ant-breadcrumb a {
  color: #64748b;
}

.zhibi-page-nav .ant-breadcrumb li:last-child {
  color: #15202b;
  font-weight: 700;
}

.zhibi-alert {
  margin-bottom: 16px;
}

.zhibi-restricted-alert {
  margin-top: 14px;
}

.zhibi-search-form .ant-form-item {
  margin-bottom: 10px;
}

.zhibi-search-form .ant-space-compact {
  width: 100%;
}

.zhibi-search-form .ant-space-compact .ant-btn:first-child {
  min-width: 96px;
}

.zhibi-search-form .ant-space-compact .ant-btn:last-child {
  min-width: 72px;
}

.zhibi-facets {
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  margin: 16px 0;
  padding: 12px;
  width: 100%;
}

.zhibi-result-list {
  margin-top: 16px;
}

.zhibi-search-loading {
  align-items: center;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border: 1px dashed #d8e2ec;
  border-radius: 14px;
  color: #64748b;
  display: flex;
  flex-direction: column;
  gap: 14px;
  justify-content: center;
  margin-top: 18px;
  min-height: 220px;
  padding: 32px 16px;
  text-align: center;
}

.zhibi-result-list .ant-list-item {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  height: 188px;
  margin-bottom: 12px;
  overflow: hidden;
  padding: 16px;
}

.zhibi-result-row {
  align-items: start;
  display: grid;
  gap: 20px;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);
  height: 100%;
  width: 100%;
}

.zhibi-result-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  overflow: hidden;
}

.zhibi-result-title {
  display: -webkit-box;
  line-height: 1.35;
  margin: 10px 0 4px;
  max-width: 100%;
  min-height: 30px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.zhibi-result-subtitle {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zhibi-highlight {
  background: #fff1a6;
  border-radius: 4px;
  color: inherit;
  font-weight: 700;
  padding: 0 2px;
}

.zhibi-result-snippet {
  display: -webkit-box;
  line-height: 1.6;
  margin-top: 8px;
  max-height: 48px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
}

.zhibi-result-snippet a {
  color: inherit;
}

.zhibi-result-detail-hint {
  color: #1f5d8c;
  display: inline-block;
  font-weight: 700;
  margin-top: 4px;
  white-space: nowrap;
}

.zhibi-result-meta {
  background: #f8fafc;
  border-radius: 10px;
  max-height: 88px;
  overflow: hidden;
  padding: 10px 12px;
  width: 100%;
}

.zhibi-result-side {
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  display: grid;
  gap: 8px;
  grid-template-rows: auto auto minmax(0, 1fr);
  height: 100%;
  overflow: hidden;
  padding: 12px;
  width: 100%;
}

.zhibi-result-side > strong {
  color: #15202b;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zhibi-result-meta .ant-descriptions-view,
.zhibi-result-meta table {
  width: 100%;
}

.zhibi-result-meta .ant-descriptions-item-label {
  white-space: nowrap;
}

.zhibi-result-meta .ant-descriptions-item-content {
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-word;
}

.zhibi-blurred-text {
  color: transparent;
  filter: blur(4px);
  font-weight: 700;
  text-shadow: 0 0 8px rgba(15, 23, 42, 0.36);
  user-select: none;
}

.zhibi-platform-detail-card {
  border: 1px solid #e5e7eb;
}

.zhibi-platform-detail-card .ant-card-head-title {
  min-width: 0;
}

.zhibi-platform-detail-locked {
  background: #fffaf0;
}

.zhibi-detail-locked-panel {
  display: grid;
  gap: 12px;
}

.zhibi-detail-blur-box {
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  display: grid;
  gap: 10px;
  padding: 14px;
}

.zhibi-detail-blur-box span {
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.35), rgba(203, 213, 225, 0.25));
  border-radius: 999px;
  display: block;
  filter: blur(3px);
  height: 14px;
}

.zhibi-detail-blur-box span:nth-child(2) {
  width: 78%;
}

.zhibi-detail-blur-box span:nth-child(3) {
  width: 54%;
}

.zhibi-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.zhibi-tweet-list {
  margin-top: 10px;
}

.zhibi-content-scope-panel {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-bottom: 10px;
  padding: 10px 12px;
}

.zhibi-content-scope-field,
.zhibi-content-meta-field {
  align-items: baseline;
  display: inline-flex;
  gap: 6px;
  max-width: 100%;
  min-width: 0;
}

.zhibi-content-scope-field {
  padding-right: 8px;
}

.zhibi-tweet-item {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 12px;
}

.zhibi-content-item-header {
  min-width: 0;
}

.zhibi-tweet-text {
  color: #15202b;
  font-size: 14px;
  line-height: 1.62;
  white-space: pre-wrap;
}

.zhibi-content-metrics .ant-tag,
.zhibi-content-item-header .ant-tag {
  margin-inline-end: 0;
}

.zhibi-tag-link,
.zhibi-tag-link:hover {
  color: inherit;
}

.zhibi-content-item-details {
  border-top: 1px solid #f1f5f9;
  padding-top: 6px;
}

.zhibi-content-item-details summary {
  color: #64748b;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.5;
  width: fit-content;
}

.zhibi-content-meta-groups {
  display: grid;
  gap: 6px;
  padding-top: 6px;
}

.zhibi-content-meta-group {
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
}

.zhibi-content-meta-group-title {
  min-width: 44px;
}

.zhibi-content-item-meta {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  padding-top: 6px;
}

.zhibi-content-meta-field .ant-typography:last-child {
  max-width: min(420px, 70vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zhibi-tweet-meta {
  background: #f8fafc;
  border-radius: 10px;
  padding: 10px 12px;
}

.zhibi-tweet-meta .ant-descriptions-item-label {
  white-space: nowrap;
}

.zhibi-tweet-meta .ant-descriptions-item-content {
  word-break: break-word;
}

.zhibi-full-width {
  width: 100%;
}

.zhibi-top-space {
  margin-top: 16px;
}

@media (max-width: 900px) {
  .zhibi-result-list .ant-list-item {
    height: auto;
    min-height: 188px;
  }

  .zhibi-result-row {
    grid-template-columns: 1fr;
  }

  .zhibi-result-meta {
    width: 100%;
  }
}
